import { useForm } from "react-hook-form";

import type { TaskFormData } from "../types/taskModal.types";

type UseTaskFormParams = {
  defaultValues: TaskFormData;
};

/* create a typed task form instance shared by task modals. */
export const useTaskForm = ({ defaultValues }: UseTaskFormParams) => {
  return useForm<TaskFormData>({
    defaultValues,
  });
};
